import { Injectable } from "@angular/core";
import { HttpApiService } from "src/commons/services/http/http-api.service";
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FooterService {

    constructor(private http: HttpApiService) { }
    
    getFooterData() {
        return this.http.getApi(environment.apiFooter);
    }

}